import { login_login_user } from "../pages/auth/types/login";
import {
  ALLOWED_MODULES_KEY,
  IS_PLATFORM_OWNER_KEY,
  IS_SUPER_ADMIN_KEY,
} from "../rest-api/queries/me";

const publicRoutes = ["/login", "/logout"];
const clientRoutes = ["/", "/moneyComments", "/orders","/discounts","/products","/returnPurchases","/defects"];

/**
 * AccountAPI/Me dan kelgan va localStorage da saqlangan ruxsatlar ro'yxati.
 * Ro'yxat bo'sh yoki buzilgan bo'lsa null qaytadi — bunday holda eski
 * (login javobidagi) ruxsatlarga tayanamiz, xodimni qulflab qo'ymaymiz.
 */
function cachedModules(): string[] | null {
  try {
    const raw = localStorage.getItem(ALLOWED_MODULES_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0) return null;
    return parsed;
  } catch {
    return null;
  }
}

export default function hasPermission(
  user: login_login_user | undefined | null,
  path?: string
) {
  if (!path) return false;

  if (publicRoutes.includes(path)) return true;

  if (path === "/" && user?.userName === "Manager") {
    path += "home";
  }

  const segment = path.split("/")[1] || "";

  if (user?.userName === "Counterparty") {
    return !!clientRoutes.find((x) => x === "/" + segment);
  }

  // Bosh sahifa ruxsati "home" nomi bilan saqlanadi.
  // "dashboard2" — o'sha bosh panelning ikkinchi ko'rinishi, shuning uchun
  // unga alohida ruxsat ochilmaydi: kimda bosh sahifa ochiq bo'lsa, bu ham
  // ochiq (aks holda menejerlarda sahifa "ruxsat yo'q" deb chiqardi).
  let cleanPath = segment || "home";
  if (cleanPath === "dashboard2") cleanPath = "home";

  // Obuna sahifasi hammaga ochiq: har kim o'z muddatini ko'ra olishi kerak,
  // aks holda bloklangan odam sababini bilmasdan qolardi. Sahifaning
  // o'zi super-admin uchun qo'shimcha bo'limlarni ko'rsatadi.
  if (cleanPath === "subscription") return true;

  // Korxonalar sahifasi — faqat tizim EGASIGA. Korxona admini ham
  // super-admin ko'rinadi va yuqoridagi umumiy shartdan o'tib ketardi,
  // shuning uchun bu tekshiruv undan OLDIN turadi. Backend baribir
  // to'sadi, lekin mijozga umuman ko'rinmagani to'g'ri.
  if (cleanPath === "tenants") {
    return localStorage.getItem(IS_PLATFORM_OWNER_KEY) === "1";
  }

  const uName = (user?.userName || "").toLowerCase();
  const isAdminName =
    uName === "administrator" ||
    uName === "moderator" ||
    uName === "super-admin" ||
    uName === "admin" ||
    uName === "superadmin";

  if (isAdminName || localStorage.getItem(IS_SUPER_ADMIN_KEY) === "1") {
    return true;
  }

  // Yangi ruxsatlar ro'yxati bor bo'lsa — aynan shunga tayanamiz.
  // Bu bo'limlar (logistics, auditLogs va boshqalar) ilgari hammaga ochiq edi.
  const modules = cachedModules();
  if (modules) {
    return modules.includes(cleanPath);
  }

  if (!user?.managerId) {
    return true;
  }

  return !!user?.manager?.managerRole?.find(
    (role) => role?.permission?.resourceName === cleanPath
  );
}
